export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_ERROR = 'REGISTER_ERROR';
export const GET_USER = 'GET_USER';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const CLOSE_SESSION = 'CLOSE_SESSION';

export const SHOW_ALERT = 'SHOW_ALERT';
export const HIDE_ALERT = 'HIDE_ALERT';

export const COUNTRY_UPDATED = 'COUNTRY_UPDATED';
export const COUNTRIES_UPDATED = 'COUNTRIES_UPDATED';
